// hooks/useSyncApplication.ts
import { useEffect, useContext } from 'react';
import { ProfileContext } from '../context/Profile.context';

export const useSyncApplication = (data, enabled = true) => {
    const [, dispatchProfile] = useContext(ProfileContext);

    useEffect(() => {
        if (enabled && data) {
            dispatchProfile({
                type: 'SET_PROFILE',
                payload: { ...data }
            });
        }
    }, [enabled]);
};